export enum BookingRequestStatus {
  VERIFIED = 'verified',
  NOT_VERIFIED = 'not_verified',
  IN_SCREENING = 'in_screening',
  CONFIRMED = 'confirmed',
  REJECTED = 'rejected',
  NEW = 'new'
}
